import { Roles } from 'constants/enums';

export const isAdmin = (role?: Roles | null) => (
  role && role === Roles.admin
);
